import PropTypes from 'prop-types';
import useLocalize from '../../../utils/hooks/useLocalize';
import './ScanCard.scss';
import ScanCardActions from './ScanCardActions';
import ScanCardFields from './ScanCardFields';
import ScanCardTimestamp from './ScanCardTimestamp';
import ScanCardTitle from './ScanCardTitle';

/**
 * ScanCard component that displays user scan details on the desktop scans page.
 *
 * @param {Object} scan - The scan object containing:
 *   - id: unique identifier
 *   - name: scan name (string)
 *   - fields: array of field objects with id and values
 *   - created: ISO timestamp of creation
 *   - updated: ISO timestamp of last update
 * @param {Function} onDetailsClick - Callback when Details link is clicked
 * @param {Function} onActionsMenuClick - Callback when ellipsis actions menu is clicked
 * @returns React component that renders the scan card
 */
const ScanCard = ({ scan, onDetailsClick, onActionsMenuClick }) => {
  const translate = useLocalize();

  return (
    <div className="desktop-scan-card">
      <ScanCardActions onMenuClick={onActionsMenuClick} scan={scan} />
      <div className="scan-card-content">
        <ScanCardTitle name={scan.name} />
        <ScanCardFields fields={scan.fields} />
        <div className="scan-card-details-section">
          <button
            className="scan-card-details-button"
            onClick={() => onDetailsClick?.(scan)}
          >
            {translate('desktop.scans.myscans.details')}
          </button>
          <ScanCardTimestamp created={scan.created} updated={scan.updated} />
        </div>
      </div>
    </div>
  );
};

ScanCard.propTypes = {
  scan: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    fields: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        values: PropTypes.arrayOf(PropTypes.string)
      })
    ),
    created: PropTypes.string,
    updated: PropTypes.string
  }).isRequired,
  onDetailsClick: PropTypes.func,
  onActionsMenuClick: PropTypes.func
};

export default ScanCard;
